// src/providers/customNotificationProvider.tsx
import { NotificationProvider } from "@refinedev/core";
import { notification } from "antd";

export const customNotificationProvider: NotificationProvider = {
  open: (params) => {
    // Don't show notifications for auth errors - we handle them inline
    if (params.key === "login-error" || params.key === "register-error") {
      return;
    }
    
    // Don't show Firebase auth errors
    if (params.message && (
      params.message.includes("auth/") || 
      params.message.includes("Firebase: Error") ||
      params.message.includes("LoginError") ||
      params.message.includes("RegisterError")
    )) {
      return;
    }

    // Show all other notifications normally
    if (params.type === "success") {
      notification.success({
        message: params.message,
        description: params.description,
        key: params.key,
      });
    } else if (params.type === "error") {
      notification.error({
        message: params.message,
        description: params.description,
        key: params.key,
      });
    } else {
      notification.info({
        message: params.message,
        description: params.description,
        key: params.key,
      });
    }
  },
  
  close: (key) => {
    notification.destroy(key);
  },
};